import * as tslib_1 from "tslib";
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { format } from 'date-fns';
import { chain, clone, isEqual, sortBy } from 'lodash';
import * as moment from 'moment-timezone';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../@fuse/services/translation-loader.service";
import * as i2 from "../../../../../../core/authentication/authentication.service";
import * as i3 from "@ngx-translate/core";
var CreateEquipmentLogsService = /** @class */ (function () {
    function CreateEquipmentLogsService(fuseTranslationLoaderService, authenticationService, translateService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.authenticationService = authenticationService;
        this.translateService = translateService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    CreateEquipmentLogsService.prototype.listEquipmentLogsMapped = function (equipment) {
        var _this = this;
        var equipmentLogsMapped = [];
        var logsSortedByCreatedAt = sortBy(equipment.logs, function (equipmentLog) { return moment(equipmentLog.createdAt); });
        logsSortedByCreatedAt.forEach(function (currentLog, index) {
            var previousLog = equipment.logs[index - 1];
            var log = tslib_1.__assign({}, currentLog, { icon: 'ic_plus_20px', eventDescription: null, eventName: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CREATED.CREATED_TITLE'), colorClass: 'light-purple', formattedCreatedAt: moment(currentLog.createdAt).local().format('DD/MM/YYYY'), createdAt: moment(currentLog.createdAt), showMessage: false, showCustomFields: false, isEquipmentCreatedLog: false });
            if (!previousLog) {
                equipmentLogsMapped.push(tslib_1.__assign({}, log, { eventDescription: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CREATED.CREATED_DESCRIPTION', {
                        number: currentLog.snapshot.number,
                        name: currentLog.snapshot.name
                    }), isEquipmentCreatedLog: true }));
                return;
            }
            var archiveOrUnarchiveLog = _this.generateArchiveOrUnarchiveLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (archiveOrUnarchiveLog) {
                equipmentLogsMapped.push(archiveOrUnarchiveLog);
            }
            var locationLog = _this.generateLocationLog({ log: log, previousLog: previousLog, currentLog: currentLog });
            if (locationLog) {
                equipmentLogsMapped.push(locationLog);
            }
            var environmentLog = _this.generateLocationEnvironmentLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (environmentLog) {
                equipmentLogsMapped.push(environmentLog);
            }
            var sectorLog = _this.generateLocationSectorLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (sectorLog) {
                equipmentLogsMapped.push(sectorLog);
            }
            var nameLog = _this.generateNameLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (nameLog) {
                equipmentLogsMapped.push(nameLog);
            }
            var numberLog = _this.generateNumberLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (numberLog) {
                equipmentLogsMapped.push(numberLog);
            }
            var typeLog = _this.generateEquipmentTypeLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (typeLog) {
                equipmentLogsMapped.push(typeLog);
            }
            var notesLog = _this.generateNotesLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (notesLog) {
                equipmentLogsMapped.push(notesLog);
            }
            var purchasedAtLog = _this.generatePurchasedAtLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (purchasedAtLog) {
                equipmentLogsMapped.push(purchasedAtLog);
            }
            var installedAtLog = _this.generateInstalledAtLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (installedAtLog) {
                equipmentLogsMapped.push(installedAtLog);
            }
            var imageUrlLog = _this.generateImageUrlLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (imageUrlLog) {
                equipmentLogsMapped.push(imageUrlLog);
            }
            var customFieldsLog = _this.generateCustomFieldsLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (customFieldsLog) {
                equipmentLogsMapped.push(customFieldsLog);
            }
            var attachmentsLog = _this.generateAttachmentsLog({ log: log, currentLog: currentLog, previousLog: previousLog });
            if (attachmentsLog) {
                equipmentLogsMapped.push(attachmentsLog);
            }
        });
        return equipmentLogsMapped;
    };
    CreateEquipmentLogsService.prototype.generateCustomFieldsLog = function (_a) {
        var _this = this;
        var log = _a.log, currentLog = _a.currentLog, previousLog = _a.previousLog;
        var currentCustomFields = chain(currentLog.snapshot.customFields)
            .map(function (_a) {
            var name = _a.name, value = _a.value;
            return ({ name: name, value: value });
        })
            .sortBy(['name', 'value'])
            .uniqBy('name')
            .value();
        var previousCustomFields = chain(previousLog.snapshot.customFields)
            .map(function (_a) {
            var name = _a.name, value = _a.value;
            return ({ name: name, value: value });
        })
            .sortBy(['name', 'value'])
            .uniqBy('name')
            .value();
        if (isEqual(currentCustomFields, previousCustomFields)) {
            return null;
        }
        var customsFieldsAdded = [];
        var customsFieldsUpdated = [];
        var customsFieldsRemoved = [];
        currentCustomFields.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            var existingCustomField = previousCustomFields.find(function (previousCustomField) {
                return previousCustomField.name === name;
            });
            if (existingCustomField) {
                if (existingCustomField.value !== value) {
                    customsFieldsUpdated.push({
                        name: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.QUESTION', {
                            question: name
                        }),
                        value: _this.normalizeCustomFieldValue(value)
                    });
                }
            }
            else {
                customsFieldsAdded.push({
                    name: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.QUESTION', {
                        question: name
                    }),
                    value: _this.normalizeCustomFieldValue(value)
                });
            }
        });
        previousCustomFields.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            var existingCustomField = currentCustomFields.find(function (currentCustomField) {
                return currentCustomField.name === name;
            });
            if (!existingCustomField) {
                customsFieldsRemoved.push({
                    name: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.QUESTION', {
                        question: name
                    }),
                    value: _this.normalizeCustomFieldValue(value)
                });
            }
        });
        var customFieldsLog = clone(log);
        customFieldsLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.UPDATED');
        customFieldsLog.icon = 'ic_chat_config_20px';
        customFieldsLog.colorClass = 'medium-gray';
        customFieldsLog.customFields = {
            added: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.ANSWER_ADDED'),
                items: customsFieldsAdded
            },
            updated: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.ANSWER_UPDATED'),
                items: customsFieldsUpdated
            },
            removed: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.ANSWER_REMOVED'),
                items: customsFieldsRemoved
            }
        };
        return tslib_1.__assign({}, customFieldsLog, { showCustomFields: true });
    };
    CreateEquipmentLogsService.prototype.generateAttachmentsLog = function (_a) {
        var log = _a.log, currentLog = _a.currentLog, previousLog = _a.previousLog;
        var currentAttachments = sortBy(currentLog.snapshot.attachments, function (attachment) { return moment(attachment.createdAt); });
        var previousAttachments = sortBy(previousLog.snapshot.attachments, function (attachment) { return moment(attachment.createdAt); });
        if (isEqual(currentAttachments, previousAttachments)) {
            return null;
        }
        var attachmentsAdded = [];
        var attachmentsRemoved = [];
        currentAttachments.forEach(function (_a) {
            var id = _a.id, path = _a.path;
            var existingCustomField = previousAttachments.find(function (previousCustomField) {
                return previousCustomField.id === id;
            });
            if (!existingCustomField) {
                attachmentsAdded.push({
                    id: id,
                    path: path
                });
            }
        });
        previousAttachments.forEach(function (_a) {
            var id = _a.id, path = _a.path;
            var existingCustomField = currentAttachments.find(function (currentCustomField) {
                return currentCustomField.id === id;
            });
            if (!existingCustomField) {
                attachmentsRemoved.push({
                    id: id,
                    path: path
                });
            }
        });
        var attachmentsLog = clone(log);
        attachmentsLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.ATTACHMENTS.TITLE');
        attachmentsLog.icon = 'ic_attachment_20px';
        attachmentsLog.colorClass = 'light-brown';
        attachmentsLog.attachments = {
            added: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.ATTACHMENTS.ADDED'),
                items: attachmentsAdded
            },
            removed: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.ATTACHMENTS.REMOVED'),
                items: attachmentsRemoved
            }
        };
        return tslib_1.__assign({}, attachmentsLog, { showAttachments: true });
    };
    CreateEquipmentLogsService.prototype.generateArchiveOrUnarchiveLog = function (_a) {
        var log = _a.log, currentLog = _a.currentLog, previousLog = _a.previousLog;
        if (currentLog.snapshot.archived === previousLog.snapshot.archived) {
            return null;
        }
        var archiveOrUnarchiveLog = clone(log);
        if (currentLog.snapshot.archived) {
            archiveOrUnarchiveLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.ARCHIVED');
            archiveOrUnarchiveLog.icon = 'ic_archive_18px';
            archiveOrUnarchiveLog.colorClass = 'light-gray';
        }
        else {
            archiveOrUnarchiveLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.UNARCHIVED');
            archiveOrUnarchiveLog.icon = 'ic_unarchive_18px';
            archiveOrUnarchiveLog.colorClass = 'dark-gray';
        }
        return archiveOrUnarchiveLog;
    };
    CreateEquipmentLogsService.prototype.generateLocationLog = function (_a) {
        var log = _a.log, previousLog = _a.previousLog, currentLog = _a.currentLog;
        if (currentLog.snapshot.location.id === previousLog.snapshot.location.id) {
            return null;
        }
        var locationLog = clone(log);
        locationLog.icon = 'ic_location_18px';
        locationLog.colorClass = 'blue';
        locationLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION.UPDATED');
        locationLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION.DESCRIPTION', {
            previousLocation: previousLog.snapshot.location.name,
            currentLocation: locationLog.snapshot.location.name
        });
        return locationLog;
    };
    CreateEquipmentLogsService.prototype.generateNumberLog = function (_a) {
        var log = _a.log, currentLog = _a.currentLog, previousLog = _a.previousLog;
        if (currentLog.snapshot.number === previousLog.snapshot.number) {
            return null;
        }
        var numberLog = clone(log);
        numberLog.icon = 'ic_chat_config_20px';
        numberLog.colorClass = 'medium-gray';
        numberLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NUMBER.UPDATED');
        numberLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NUMBER.DESCRIPTION', {
            previousNumber: previousLog.snapshot.number,
            currentNumber: currentLog.snapshot.number
        });
        return numberLog;
    };
    CreateEquipmentLogsService.prototype.generateNameLog = function (_a) {
        var log = _a.log, currentLog = _a.currentLog, previousLog = _a.previousLog;
        if (currentLog.snapshot.name === previousLog.snapshot.name) {
            return null;
        }
        var nameLog = clone(log);
        nameLog.icon = 'ic_chat_config_20px';
        nameLog.colorClass = 'medium-gray';
        nameLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NAME.UPDATED');
        nameLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NAME.DESCRIPTION', {
            previousName: previousLog.snapshot.name,
            currentName: currentLog.snapshot.name
        });
        return nameLog;
    };
    CreateEquipmentLogsService.prototype.generateEquipmentTypeLog = function (_a) {
        var log = _a.log, currentLog = _a.currentLog, previousLog = _a.previousLog;
        if (currentLog.snapshot.type.id === previousLog.snapshot.type.id) {
            return null;
        }
        var typeLog = clone(log);
        typeLog.icon = 'ic_chat_config_20px';
        typeLog.colorClass = 'medium-gray';
        typeLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.TYPE.UPDATED');
        typeLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.TYPE.DESCRIPTION', {
            previousType: previousLog.snapshot.type.name,
            currentType: currentLog.snapshot.type.name
        });
        return typeLog;
    };
    CreateEquipmentLogsService.prototype.generateNotesLog = function (_a) {
        var log = _a.log, previousLog = _a.previousLog, currentLog = _a.currentLog;
        if (currentLog.snapshot.notes === previousLog.snapshot.notes) {
            return null;
        }
        var notesLog = clone(log);
        if (!previousLog.snapshot.notes && currentLog.snapshot.notes) {
            notesLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.CREATED_TITLE');
        }
        if (previousLog.snapshot.notes &&
            currentLog.snapshot.notes &&
            previousLog.snapshot.notes !== currentLog.snapshot.notes) {
            notesLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.UPDATED_TITLE');
        }
        if (previousLog.snapshot.notes && !currentLog.snapshot.notes) {
            notesLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.REMOVED_TITLE');
        }
        notesLog.icon = 'ic_chat_20px';
        notesLog.eventDescription = currentLog.snapshot.notes;
        notesLog.colorClass = 'gray';
        return tslib_1.__assign({}, notesLog, { showMessage: true });
    };
    CreateEquipmentLogsService.prototype.generatePurchasedAtLog = function (_a) {
        var log = _a.log, previousLog = _a.previousLog, currentLog = _a.currentLog;
        if (currentLog.snapshot.purchasedAt === previousLog.snapshot.purchasedAt) {
            return null;
        }
        var purchasedAtLog = clone(log);
        purchasedAtLog.colorClass = 'medium-gray';
        purchasedAtLog.icon = 'ic_chat_config_20px';
        if (!previousLog.snapshot.purchasedAt && currentLog.snapshot.purchasedAt) {
            purchasedAtLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.PURCHASED_AT.CREATED.TITLE');
            purchasedAtLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.PURCHASED_AT.CREATED.DESCRIPTION', {
                current: format(new Date(currentLog.snapshot.purchasedAt), 'dd/MM/yyyy')
            });
        }
        if (previousLog.snapshot.purchasedAt && currentLog.snapshot.purchasedAt && previousLog.snapshot.purchasedAt !== currentLog.snapshot.purchasedAt) {
            purchasedAtLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.PURCHASED_AT.UPDATED.TITLE');
            purchasedAtLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.PURCHASED_AT.UPDATED.DESCRIPTION', {
                previous: format(new Date(previousLog.snapshot.purchasedAt), 'dd/MM/yyyy'),
                current: format(new Date(currentLog.snapshot.purchasedAt), 'dd/MM/yyyy')
            });
        }
        if (previousLog.snapshot.purchasedAt && !currentLog.snapshot.purchasedAt) {
            purchasedAtLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.PURCHASED_AT.REMOVED.TITLE');
            purchasedAtLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.PURCHASED_AT.REMOVED.DESCRIPTION', {
                previous: format(new Date(previousLog.snapshot.purchasedAt), 'dd/MM/yyyy')
            });
        }
        return tslib_1.__assign({}, purchasedAtLog, { showMessage: true });
    };
    CreateEquipmentLogsService.prototype.generateInstalledAtLog = function (_a) {
        var log = _a.log, previousLog = _a.previousLog, currentLog = _a.currentLog;
        if (currentLog.snapshot.installedAt === previousLog.snapshot.installedAt) {
            return null;
        }
        var installedAtLog = clone(log);
        installedAtLog.colorClass = 'medium-gray';
        installedAtLog.icon = 'ic_chat_config_20px';
        if (!previousLog.snapshot.installedAt && currentLog.snapshot.installedAt) {
            installedAtLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.INSTALLED_AT.CREATED.TITLE');
            installedAtLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.INSTALLED_AT.CREATED.DESCRIPTION', {
                current: format(new Date(currentLog.snapshot.installedAt), 'dd/MM/yyyy')
            });
        }
        if (previousLog.snapshot.installedAt && currentLog.snapshot.installedAt && previousLog.snapshot.installedAt !== currentLog.snapshot.installedAt) {
            installedAtLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.INSTALLED_AT.UPDATED.TITLE');
            installedAtLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.INSTALLED_AT.UPDATED.DESCRIPTION', {
                previous: format(new Date(previousLog.snapshot.installedAt), 'dd/MM/yyyy'),
                current: format(new Date(currentLog.snapshot.installedAt), 'dd/MM/yyyy')
            });
        }
        if (previousLog.snapshot.installedAt && !currentLog.snapshot.installedAt) {
            installedAtLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.INSTALLED_AT.REMOVED.TITLE');
            installedAtLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.INSTALLED_AT.REMOVED.DESCRIPTION', {
                previous: format(new Date(previousLog.snapshot.installedAt), 'dd/MM/yyyy')
            });
        }
        return tslib_1.__assign({}, installedAtLog, { showMessage: true });
    };
    CreateEquipmentLogsService.prototype.generateImageUrlLog = function (_a) {
        var log = _a.log, previousLog = _a.previousLog, currentLog = _a.currentLog;
        var isSame = currentLog.snapshot.imageUrl === previousLog.snapshot.imageUrl;
        if (isSame) {
            return null;
        }
        var imageUrlLog = clone(log);
        var isCreated = !previousLog.snapshot.imageUrl && currentLog.snapshot.imageUrl;
        var isRemoved = previousLog.snapshot.imageUrl && !currentLog.snapshot.imageUrl;
        var isUpdated = !isCreated && !isRemoved && currentLog.snapshot.imageUrl !== previousLog.snapshot.imageUrl;
        imageUrlLog.icon = 'ic_chat_config_20px';
        imageUrlLog.colorClass = 'medium-gray';
        if (isCreated) {
            imageUrlLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.IMAGE_URL.CREATED');
            imageUrlLog.attachments = {
                added: {
                    items: [{ path: currentLog.snapshot.imageUrl }]
                },
            };
        }
        if (isUpdated) {
            imageUrlLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.IMAGE_URL.UPDATED');
            imageUrlLog.attachments = {
                added: {
                    items: [{ path: currentLog.snapshot.imageUrl }]
                }
            };
        }
        if (isRemoved) {
            imageUrlLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.IMAGE_URL.REMOVED');
            imageUrlLog.attachments = {
                removed: {
                    items: [{ path: previousLog.snapshot.imageUrl }]
                }
            };
        }
        return tslib_1.__assign({}, imageUrlLog, { showAttachments: true });
    };
    CreateEquipmentLogsService.prototype.generateLocationEnvironmentLog = function (_a) {
        var log = _a.log, currentLog = _a.currentLog, previousLog = _a.previousLog;
        var currentEnvironmentId = currentLog.snapshot.locationEnvironment && currentLog.snapshot.locationEnvironment.id;
        var previousEnvironmentId = previousLog.snapshot.locationEnvironment && previousLog.snapshot.locationEnvironment.id;
        var isSameEnvironmentId = currentEnvironmentId === previousEnvironmentId;
        if (isSameEnvironmentId) {
            return null;
        }
        var equipmentLog = clone(log);
        var isEnvironmentAdded = !previousEnvironmentId && currentEnvironmentId;
        var isEnvironmentRemoved = previousEnvironmentId && !currentEnvironmentId;
        var isEnvironmentUpdated = !isEnvironmentAdded && !isEnvironmentRemoved && currentEnvironmentId !== previousEnvironmentId;
        equipmentLog.icon = 'icon_space_20px';
        equipmentLog.colorClass = 'dark-blue';
        var params = {
            previous: previousEnvironmentId && previousLog.snapshot.locationEnvironment.name,
            current: currentEnvironmentId && currentLog.snapshot.locationEnvironment.name
        };
        if (isEnvironmentAdded) {
            equipmentLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_ENVIRONMENT.CREATED');
            equipmentLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_ENVIRONMENT.CREATED_DESCRIPTION', params);
        }
        if (isEnvironmentRemoved) {
            equipmentLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_ENVIRONMENT.REMOVED');
            equipmentLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_ENVIRONMENT.REMOVED_DESCRIPTION', params);
        }
        if (isEnvironmentUpdated) {
            equipmentLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_ENVIRONMENT.UPDATED');
            equipmentLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_ENVIRONMENT.UPDATED_DESCRIPTION', params);
        }
        return equipmentLog;
    };
    CreateEquipmentLogsService.prototype.generateLocationSectorLog = function (_a) {
        var log = _a.log, currentLog = _a.currentLog, previousLog = _a.previousLog;
        var currentSectorId = currentLog.snapshot.locationSector && currentLog.snapshot.locationSector.id;
        var previousSectorId = previousLog.snapshot.locationSector && previousLog.snapshot.locationSector.id;
        var isSameSectorId = currentSectorId === previousSectorId;
        if (isSameSectorId) {
            return null;
        }
        var equipmentLog = clone(log);
        var isSectorAdded = !previousSectorId && currentSectorId;
        var isSectorRemoved = previousSectorId && !currentSectorId;
        var isSectorUpdated = !isSectorAdded && !isSectorRemoved && currentSectorId !== previousSectorId;
        equipmentLog.icon = 'icon_space_20px';
        equipmentLog.colorClass = 'dark-blue';
        var params = {
            previous: previousSectorId && previousLog.snapshot.locationSector.name,
            current: currentSectorId && currentLog.snapshot.locationSector.name
        };
        if (isSectorAdded) {
            equipmentLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_SECTOR.CREATED');
            equipmentLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_SECTOR.CREATED_DESCRIPTION', params);
        }
        if (isSectorRemoved) {
            equipmentLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_SECTOR.REMOVED');
            equipmentLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_SECTOR.REMOVED_DESCRIPTION', params);
        }
        if (isSectorUpdated) {
            equipmentLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_SECTOR.UPDATED');
            equipmentLog.eventDescription = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION_SECTOR.UPDATED_DESCRIPTION', params);
        }
        return equipmentLog;
    };
    CreateEquipmentLogsService.prototype.normalizeCustomFieldValue = function (value) {
        var datePattern = /^\d{4}-\d{2}-\d{2}/;
        return datePattern.test(value) ? moment(value).local().format('DD/MM/YYYY') : value;
    };
    CreateEquipmentLogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CreateEquipmentLogsService_Factory() { return new CreateEquipmentLogsService(i0.ɵɵinject(i1.FuseTranslationLoaderService), i0.ɵɵinject(i2.AuthenticationService), i0.ɵɵinject(i3.TranslateService)); }, token: CreateEquipmentLogsService, providedIn: "root" });
    return CreateEquipmentLogsService;
}());
export { CreateEquipmentLogsService };
